import styled from '@emotion/styled';

export const StyledSectionTitle = styled('div')({
  color: '#6B7280',
  fontSize: '0.875rem',
  fontWeight: 600,
});
